import api from "@/api/api-v2-config";

export async function getProductAxios(isActive = null) {    
    return await api.get(`products?PageSize=1000000&PageNumber=1${isActive != null ? '&IsActive=' + isActive : '' }`);
}

export async function getProductIDAxios(id) {    
    return await api.get("products/"+ id);
}

export async function deleteProductAxios(id) {    
    return await api.delete("products?ProductId=" + id);
}

export async function postProductAxios(item) {    
    return await api.post("products", item);
}

export async function putProductAxios(item) {    
    return await api.put("products", item);
}

export async function deleteProductimageAxios(id) {   
    return await api.delete("products/" + id);
}

export async function postProductFileAxios(data) {    
    let payload = new FormData();
    payload.append("ItemId", data.itemId);
    payload.append("Image", data.file);
    api.defaults.headers["Content-Type"] = data.file.type;
    const res = await api.post("products/productimage", payload);
    api.defaults.headers["Content-Type"] = "application/json";
    return res;
}


export async function getProductDocumentList(ReferenceID) {
    return await api.get(`products/files?ReferenceID=${ReferenceID}&PageNumber=1&PageSize=10000`);
}


export async function deleteProductDocument(id) {
    return await api.delete("products/files/" + id);
}

export async function uploadProductDocument(file, referenceId, type, typeId) {
    console.log(file, referenceId);
    const formData = new FormData();
    formData.append('File', file[0]);
    formData.append('ReferenceId', referenceId);
    formData.append('type', type);
    formData.append('typeId', typeId);
    api.defaults.headers["Content-Type"] = "multipart/form-data";
    return await api.post('products/files/upload', formData);
}

export async function uploadProductMultipleDocuments(files, referenceId, type, typeId) {
    console.log(files, referenceId);
    const formData = new FormData();
    files.forEach(file => {
        formData.append('Files', file);
    });
    formData.append('ReferenceId', referenceId);
    formData.append('type', type);
    formData.append('typeId', typeId);
    api.defaults.headers["Content-Type"] = "multipart/form-data";
    return await api.post('products/files/uploads', formData);
}


export async function downloadProductDocument(id) {
    api.defaults.headers["responseType"] = "blob";
    return await api.get("products/files/download/" + id);
}